<script>
import Chart from "../chart.vue";
import forcastchart from "./forcastchart";

export default {
  name: "ForcastChart",
  extends: Chart,
  mounted() {
    var ref = this;
    this.$nextTick(function () {
      ref.chart = new forcastchart(
        ref.$refs.chart,
        JSON.parse(JSON.stringify(ref.chartdata)),
        ref.config
      );
    });
  },
  watch: {
    chartdata: {
      deep: true,
      handler(val) {
        console.log("chartdata changed: ", val);
      },
    },
  },
};
</script>

<style lang="scss">
@import "../styles";

.chart--areachart {
  max-width: 320px;
  .chart__area {
    fill: var(--bg-color);
    opacity: 0.3;
    stroke-linejoin: round;
  }
  .chart__area__Forecast__noAction {
    fill: var(--bg-color);
    opacity: 0.3;
    stroke-linejoin: round;
  }
  .chart__areaFor {
    fill: #2dc4b2;
    opacity: 0.3;
    stroke-linejoin: round;
    stroke: #2dc4b2;
  }
  .chart__line {
    opacity: 0.9;
    stroke-linejoin: round;
    stroke-width: 2;
    stroke: var(--bg-color);
  }
  .chart__line__Forecast__noAction {
    opacity: 0.9;
    stroke-linejoin: round;
    stroke-width: 2;
    stroke: var(--bg-color);
    stroke-dasharray: 7, 2;
  }
  .chart__lineForcast {
    opacity: 0.9;
    stroke-linejoin: round;
    stroke-width: 2;
    stroke: #2dc4b2;
  }
  .chart__dateLine {
    opacity: 0.8;
    stroke-width: 1;
    stroke: black;
  }
}
</style>
